<template>
  <div
    class="home"
    v-loading.body="loading"
    element-loading-text="开票中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!-- 路由 -->
    <LeftNav></LeftNav>
    <!-- 头部 -->
    <Header></Header>
    <!-- 面包屑 -->
    <Bread></Bread>
    <!-- 二级路由 -->
    <router-view @getMessage="showMsg"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    };
  },
  components: {
    LeftNav: () => import("@/components/leftNav.vue"),
    Header: () => import("@/components/header.vue"),
    Bread: () => import("@/components/bread.vue"),
  },
  mounted() {
    // document.cookie = "token=zyw0052_67a3eb02235f47dc8d8f778a09587e5d";
    // document.cookie = "token=zxb0006_02e52a6e400e4a519fa0e86b68cbf7a0";
    // document.cookie = "token=zzb0013_d4bee19a40d642d780615b9e940b8df1";
    // js代码中使用环境变量
    // console.log("BASE_URL: ", process.env.BASE_URL);
    // console.log("VUE_APP_API: ", process.env.VUE_APP_BASE_API);
  },
  methods: {
    showMsg(val) {
      this.loading = val;
      console.log(val);
    },
  },
};
</script>
